import React from 'react';
import Link from 'next/link';
import cn from 'classnames';

import styles from './VideoList.module.css';

const VideoList = ({ items }) => (
  <section className="container">
    <ul>
      {items.map((item, i) => (
        <VideoItem key={`video-item-${item.name}`} content={item.poster} reverse={i % 2 !== 0} />
      ))}
    </ul>
  </section>
);

const VideoItem = ({ content, reverse }) => (
  <li className="mb-5 lg:mb-11">
    <Link href={content.href}>

      <article className={cn(styles.grid, { [`${styles.reverse}`]: reverse })}>
        <div className={`${styles.img}`}>
          <img
            className="object-cover w-full h-auto lg:h-full"
            src={`/static/img/website/interviews/tailwind/video-cards/${content.imageSrc}.png`}
            alt={content.name}
          />
        </div>
        <header
          className={`${styles.content} text-white flex flex-col justify-center py-10 lg:py-0 px-6 md:px-10 lg:pl-24 lg:pr-16`}
        >
          <span className="block mb-4 text-overtitle text-scale-mauve">{content.episode}</span>
          <h2 className="mb-4 text-2xl text-white md:text-4xl">{content.name}</h2>
          <p className="mb-12 text-base md:text-lg">{content.description}</p>
          <div className="flex items-center">
            <div className="w-8 h-8 mr-6">{playIcon}</div>
            <span className="text-base md:text-lg">Watch Interview</span>
          </div>
        </header>
      </article>

    </Link>
  </li>
);

const playIcon = (
  <svg viewBox="0 0 32 32" className="w-full h-full">
    <path
      d="M16 0C7.16129 0 0 7.16129 0 16C0 24.8387 7.16129 32 16 32C24.8387 32 32 24.8387 32 16C32 7.16129 24.8387 0 16 0ZM23.4645 17.5484L12.1097 24.0645C11.0903 24.6323 9.80645 23.9032 9.80645 22.7097V9.29032C9.80645 8.10323 11.0839 7.36774 12.1097 7.93548L23.4645 14.8387C24.5226 15.4323 24.5226 16.9613 23.4645 17.5484Z"
      fill="white"
    />
  </svg>
);

export default VideoList;
